import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {DxConfigService} from "./dx-config.service";
import {DxAppError} from "../domain/error/dx-app-error";


/**
 * Сервис предоставляет функциональность для обработки ошибок приложения
 * (чтобы не перегружать этим перехватчик).
 * @publicApi
 */
@Injectable()
export class DxErrorService {
  /**
   * Последняя перехваченная ошибка.
   * @name _lastError
   * @type {DxAppError}
   */
  private _lastError: DxAppError;

  /**
   * @constructor
   * @param {Router} _router - роутер.
   * @param {DxConfigService} _configService - сервис, предоставляющий достп к конфигурации ядра.
   */
  constructor(private _router: Router,
              private _configService: DxConfigService) {
  }


  /**
   * Возвращает последнюю перехваченную ошибку.
   * @return {DxAppError} - последняя ошибка, отловленная глобальным перехватчиком.
   * @public
   */
  get lastError(): DxAppError {
    return this._lastError;
  }

  /**
   * Устанавливает последнюю перехваченную ошибку.
   * @param {DxAppError} value - последняя перехваченная ошибка.
   * @public
   */
  set lastError(value: DxAppError) {
    this._lastError = value;
  }


  /**
   * Редиректит на аварийную страницу.
   * @public
   */
  public redirectToErrorPage(): void {
    this._router.navigate([this._configService.errorRoute]);
  }


  /**
   *   Фабричная функция для преобразования ошибок к одному стандарту.
   *   Ошибок может прилетать много и разных (с разной структурой полей).
   *   В этой функции их нужно сортировать и приводить к единому стандарту,
   *   чтобы гарантировать состав полей в объекте.
   *
   *   @param {any} error - объект тошибки произвольного типа.
   *   @return {DxAppError} - унифицированный объект ошибки приложения.
   */
  public static buildDxAppError(error: any): DxAppError {
    // Пока что реализация тривиальная
    const dxError = new DxAppError();
    dxError.name = error.name;
    dxError.message = error.message;
    dxError.stackTrace = error.stack;
    dxError.origin = error;
    return dxError;
  }
}
